// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SettingsDisplay_wrapper__x__PH","notificationsButton":"SettingsDisplay_notificationsButton__YyLOq"};